import {
  GET_ISSUES
} from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_ISSUES] (state, issues) { state.all = issues } }

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/issues.js